module.exports = __webpack_public_path__ + "img/pinterest.95c4f4e5.png";